"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectAssign2 = _interopRequireDefault(require("object-assign"));
var _contentTypes = require("./content-types");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PayloadTransformer = exports.default = /*#__PURE__*/function () {
  function PayloadTransformer() {
    _classCallCheck(this, PayloadTransformer);
  }
  return _createClass(PayloadTransformer, [{
    key: "toRequest",
    value:
    /**
     * @param {Object} data
     * @param {string} [contentType = APPLICATION_JSON]
     * @returns {Object}
     */
    function toRequest(data) {
      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _contentTypes.APPLICATION_JSON;
      if (data && (0, _utils.includes)(contentType, _contentTypes.APPLICATION_JSON)) {
        return JSON.stringify(data);
      }
      return data;
    }

    /**
     * @param {XMLHttpRequest} xhr
     * @returns {Object}
     * @property {Object} data
     * @property {number} status
     * @property {string} statusText
     */
  }, {
    key: "fromResponse",
    value: function fromResponse(xhr) {
      var headers = this.parseResponseHeaders(xhr.getAllResponseHeaders());
      var contentType = xhr.getResponseHeader('Content-Type');
      var status = xhr.status,
        statusText = xhr.statusText;
      var data = 'response' in xhr ? xhr.response : xhr.responseText;
      if (data && (0, _utils.includes)(contentType, _contentTypes.APPLICATION_JSON)) {
        data = JSON.parse(data);
      }
      return {
        data: data,
        headers: headers,
        status: status,
        statusText: statusText
      };
    }

    /**
     * @private
     * @param {string} rawHeaders
     * @returns {Object}
     */
  }, {
    key: "parseResponseHeaders",
    value: function parseResponseHeaders(rawHeaders) {
      var lines = rawHeaders ? rawHeaders.replace(/\r?\n[\t ]+/g, ' ').split(/\r?\n/) : [];
      return lines.reduce(function (headers, line) {
        var parts = line.split(':');
        var key = (parts.shift() || '').trim();
        if (!key) {
          return headers;
        }
        return (0, _objectAssign2.default)({}, headers, _defineProperty({}, key.toLowerCase(), parts.join(':').trim()));
      }, {});
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {PayloadTransformer}
     */
    function create() {
      return new PayloadTransformer();
    }
  }]);
}();
//# sourceMappingURL=payload-transformer.js.map